var base = require('kiosk/announcements');

Vue.component('spark-kiosk-announcements', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/kiosk/announcements.js